import React from "react"

import PriorSteps from "./PriorSteps"

const LoopPriorSteps = ({
  stepComponent,
  // priorStepsSupplierItems = [], KFC-2429 - To be added
  isEdition,
  onRowBlur,
  onRowHover,
  index,
  sectionIndex,
  indexComponent,
  hasError,
  step,
  transformationModes,
  isStepComponentHover,
  setFieldValue,
  steps,
  section,
  recipe,
  fromRecipe,
  stepComponentsIndexesList,
  isReusable
}) => {
  // // Retrieve all the supplier items from the steps and create a map of them
  // const currentSupplierItems = [
  //   ...new Map([
  //     ...(stepComponent.priorStepsSupplierItems || []),
  //     ...(priorStepsSupplierItems || [])
  //   ].map(i => [i.index, i])).values()
  // ]
  // const supplierItemsMap = Object.fromEntries(currentSupplierItems.map(item => [item.index, item])) KFC-2429 - To be added

  const type = stepComponent.priorSteps ? "priorSteps" : "sectionOutput"
  const subStepComponents = stepComponent[type].stepComponents || []
  return (
    subStepComponents.map((subStepComponent, indexSubComponent) => {
      // Retrieve the prior step component supplier item
      // const supplierItemForSubStep = supplierItemsMap[subStepComponent.index] || null

      return (
        (!subStepComponent.supplierItem && (subStepComponent.priorSteps?.stepComponents.length > 0 || subStepComponent.sectionOutput))
          ? (
            <LoopPriorSteps
              stepComponent={subStepComponent}
              // priorStepsSupplierItems={currentSupplierItems || []} // KFC-2429 - To be added
              isEdition={isEdition}
              onRowBlur={onRowBlur}
              onRowHover={onRowHover}
              index={index}
              sectionIndex={sectionIndex}
              indexComponent={indexSubComponent}
              hasError={hasError}
              step={step}
              transformationModes={transformationModes}
              isStepComponentHover={isStepComponentHover}
              setFieldValue={setFieldValue}
              key={indexSubComponent + "priorSteps"}
              steps={steps}
              section={section}
              recipe={recipe}
              fromRecipe={fromRecipe}
              stepComponentsIndexesList={stepComponentsIndexesList.concat(indexSubComponent)}
              isReusable={isReusable}
            />
          )
          : (
            <PriorSteps
              type={stepComponent.sectionOutput ? "sectionOutput" : "priorSteps"}
              isEdition={isEdition}
              onRowBlur={onRowBlur}
              onRowHover={onRowHover}
              index={index}
              sectionIndex={sectionIndex}
              indexComponent={indexComponent}
              hasError={hasError}
              step={step}
              transformationModes={transformationModes}
              isStepComponentHover={isStepComponentHover}
              setFieldValue={setFieldValue}
              indexSubComponent={indexSubComponent}
              subStepComponent={subStepComponent}
              key={indexSubComponent + "priorSteps"}
              steps={steps}
              section={section}
              recipe={recipe}
              fromRecipe={fromRecipe}
              stepComponentsIndexesList={stepComponentsIndexesList.concat(indexSubComponent)}
              isReusable={isReusable}
            // priorStepSupplierItem={supplierItemForSubStep} // KFC-2429 - To be added
            />
          )
      )
    }
    )
  )
}

export default LoopPriorSteps
